module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "شكر-وتقدير"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكر وتقدير")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تحية شكر وعرفان بالجميل لفكر الشاعر العظيم أبي القاسم الشابي الذي اقتبستُ من قصيدتهِ \"إرادة الحياة\" جميع الأبيات المذكورة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشكر بشكل خاص أستاذي معلم اللغة الإنجليزية السيد")]), _vm._v(" A.J Hoge "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأب المؤسس لنظام تعلم الإنجليزية دون مجهود")]), _vm._v("Effortless English"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، الذي دون أسلوبه السهل المبسط لما استطعت تعلم اللغة الإنجليزية. والتي من خلالها أمكنني أن أدرس علوم العقل وتنمية الذات وقوانين الطبيعة من كتب باللغة الإنجليزية بالأساس، وقد لمستُ فرقاً كبيراً، فقد درستُ من سنوات طويلة كتباً مترجمة للعربية، ولكني وجدتُ أن الترجمة غالباً ما تفقد المحتوى جزءاً من صلبه فيضيع المعنى، وبخاصة إذا لم تُترجم على يد متمكِّن بكلتا اللغتين، يدرك تماماً مجال علم الكتاب والتمييز بين المصطلحات المتشابكة، فيحافظ على توحيدها. برأيي يستحسن قراءة الكتب باللغة الأصلية التي صدرت بها لعمقٍ أفضل في الفهم والاستيعاب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشكر أيضاً المعلم الجليل، معلم الثراء الأول وعلوم العقل والتنمية البشرية السيد")]), _vm._v(" Bob Proctor "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أحد أهم ملهميَّ، والأساس في ترتيب طيف أفكاري، ذلك من خلال دراستي لبعض البرامج التي أعدتها مؤسسته")]), _vm._v(" Proctor Gallagher Institute"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشكر أيضاً كل من مَرَّ بحياتي من زملاء ومعارف وأشخاص وأقارب سواء من هم على قيد الحياة أو سبقونا إلى العالم الحقيقي، وأشكر كل من ألهمني بأي شكل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشكر كل من دعمني ورفع من معنوياتي،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حتى الأشخاص الذين لم تكن تجربتي إيجابية معهم، ومَن جعلوا الحياة أصعب في نظري. شكراً لهم فقد جعلوني أكثر نضجاً وصلابةً وإصراراً، كما أرجو المعذرة مِن مَن أخطأتُ بحقهم، لقد اكتسبت منهم الخبرة والدروس وأرجو أن يكونوا هم كذلك. نعم أؤكد الشكر للجميع بلا استثناء، فالجميع ساهم بقدر أو بآخر بإنجاز هذا الكتاب بحجم دوره بحياتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0